import { Navigate } from 'react-router-dom';
import HomePage from '../../page/home';
import useUserStore from '../../store/user';

export default function RootRedirect() {
  const user = useUserStore(state => state.user);
  const pendingInvitationCode = useUserStore(
    state => state.pendingInvitationCode,
  );

  // If no user, show the login page
  if (!user) {
    return <HomePage />;
  }

  // If user exists, redirect based on their role
  if (pendingInvitationCode) {
    return (
      <Navigate
        to={`/invitation/${pendingInvitationCode}`}
        replace
        state={{ from: '/' }}
      />
    );
  }

  return <Navigate to={user.isManager ? '/manager/home' : '/profile'} replace />;
}
